import HorizontalBannerComponent from '@molecules/HorizontalBannerComponent/HorizontalBannerComponent';
import { EcommerceEvent, pushGTMEcommerceEvent } from '@helpers/analyticsHelpers/pushGTMEvent';
import type { ComponentWsDTO } from '@occ/api-client';

interface Props {
  data: ComponentWsDTO;
  context: SlotContextType;
}

const TrackedHorizontalBannerComponent = ({ data, context }: Props) => {
  const logImpression = () => {
    pushGTMEcommerceEvent({
      event: EcommerceEvent.VIEW_PROMOTION,
      ecommerce: {
        promotion_id: data.name || 'hero',
        creative_name: 'hero',
        creative_slot: `${context.slotName} ${context.slotPosition}`,
      },
    });
  };

  const onClick = () => {
    pushGTMEcommerceEvent({
      event: EcommerceEvent.SELECT_PROMOTION,
      ecommerce: {
        promotion_id: data.name || 'hero',
        creative_name: 'hero',
        creative_slot: `${context.slotName} ${context.slotPosition}`,
      },
    });
  };

  return <HorizontalBannerComponent data={data} logImpression={logImpression} onClick={onClick} />;
};

export default TrackedHorizontalBannerComponent;
